import axios from 'axios';
import {getHttpRequestWithOwnInstance} from '../../utils/axios/getHttpRequestWithOwnInstance';
import {setupCache} from 'axios-cache-interceptor';
import {
  AdditionalApiOptions,
  CancelableApiPromise,
  IApiClientFactory,
  withOptions,
} from '../../utils/axios/withOptions';
import {addStandardInterceptors} from '../../utils/axios/interceptors/addStandardInterceptors';
import {EntitlementsApiServiceExtended} from './EntitlementsApiServiceExtended';
import {EntitlementsApiService} from './EntitlementsApiService';
import {API_BASE_PATHS} from '../apiBasePaths';

const axiosInstance = axios.create({});

const CACHE_TTL_MS = 5 * 60 * 1000;

export const API_BASE_URL = API_BASE_PATHS.entitlements.path;

setupCache(axiosInstance, {
  ttl: CACHE_TTL_MS,
  methods: ['get'],
  cachePredicate: {
    responseMatch: _response => {
      // Manually check the URL from the response config
      //return !!response.config.url?.includes('api/me');
      return false;
    },
  },
});

addStandardInterceptors(axiosInstance);

export const getEntitlementsApiService: IApiClientFactory<
  EntitlementsApiService
> = options => {
  const client = new EntitlementsApiServiceExtended(
    {
      BASE: '',
      WITH_CREDENTIALS: true,
    },
    getHttpRequestWithOwnInstance(axiosInstance, {
      ...options,
      baseUrl: () => API_BASE_URL,
    }),
  );

  return client;
};

export const EntitlementsApiClient = getEntitlementsApiService();

export function entitlementsApiClientWithOptions<TResponse>(
  action: (client: EntitlementsApiService) => CancelableApiPromise<TResponse>,
  options?: AdditionalApiOptions,
): CancelableApiPromise<TResponse> {
  return withOptions(getEntitlementsApiService, action, options);
}
